import { createTypes, createAction } from "lib/action";

const LOAD_STRENGTH = createTypes("strength", "load");
const SHOW_STRENGTH = createTypes("strength", "show");
const CREATE_STRENGTH = createTypes("strength", "create");
const UPDATE_STRENGTH = createTypes("strength", "update");
const DELETE_STRENGTH = createTypes("strength", "delete");
const IMPORT_STRENGTH = createTypes("strength", "import");
const EXPORT_STRENGTH = createTypes("strength", "export");

const loadStrengths = {
  request: (params, token) =>
    createAction(LOAD_STRENGTH.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_STRENGTH.FAILURE, { err }),
};

const showStrength = {
  request: (id, token) => createAction(SHOW_STRENGTH.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_STRENGTH.FAILURE, { err }),
};

const createStrength = {
  request: (params, token) =>
    createAction(CREATE_STRENGTH.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_STRENGTH.FAILURE, { err }),
};

const updateStrength = {
  request: (params, id, token) =>
    createAction(UPDATE_STRENGTH.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_STRENGTH.FAILURE, { err }),
};

const deleteStrength = {
  request: (id, token) => createAction(DELETE_STRENGTH.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_STRENGTH.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_STRENGTH.FAILURE, { err }),
};

const importStrength = {
  request: (file, company_id, token) =>
    createAction(IMPORT_STRENGTH.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_STRENGTH.FAILURE, { err }),
};

const exportStrength = {
  request: (token) => createAction(EXPORT_STRENGTH.REQUEST, { token }),
  success: (data) => createAction(EXPORT_STRENGTH.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_STRENGTH.FAILURE, { err }),
};

export {
  loadStrengths,
  showStrength,
  createStrength,
  updateStrength,
  deleteStrength,
  importStrength,
  exportStrength,
  LOAD_STRENGTH,
  SHOW_STRENGTH,
  CREATE_STRENGTH,
  UPDATE_STRENGTH,
  DELETE_STRENGTH,
  IMPORT_STRENGTH,
  EXPORT_STRENGTH,
};
